import { Typography } from "@material-tailwind/react";

const Footer = () => {
    const currentYear = new Date().getFullYear();

    return (
        <footer className="w-full bg-blue-gray-800 py-4">
            <div className="w-[calc(100%-2rem)] max-w-[350px] mx-auto px-3 sm:px-4">
                <div className="flex justify-center items-center">
                    <Typography variant="small" color="white" className="opacity-70">
                        Muslimani.info - {currentYear}
                    </Typography>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
